import React from "react"
import { AntSwitchSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"
import AppIconChipToggle from "./IconChipToggle"


// A yes / no setting. With its two names (falseText / trueText) it is the two-option selector of the
// Dataseekers retail front; without names (the Off/On of a table row) it stays a small switch.
// onChange gets the same `e.target.checked` it always got, so no screen changes its logic.
export default function AppAntSwitch({ falseText = null, trueText = null, falseIcon, trueIcon, checked, onChange, disabled, size = 'small', ...props }) {
	if (falseText || trueText) {
		return <AppIconChipToggle
			size={size}
			value={!!checked}
			disabled={disabled}
			options={[
				{ value: false, label: falseText, icon: falseIcon },
				{ value: true, label: trueText, icon: trueIcon },
			]}
			onChange={value => onChange?.({ target: { checked: value } }, value)}
			sx={props.chipSx}
		/>
	}

	return <AntSwitchSeeker
		checked={checked}
		onChange={onChange}
		disabled={disabled}
		formControlProps={{
			sx: { width: 45 },
		}}
		sx={{
			left: -11,
			width: 65,
			".Mui-checked": {
				right: 10
			},
			'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: dsColorNew.appBlue, opacity: 1 },
			...props.switchProps
		}}
		falseProps={{ sx: { display: 'none' } }}
		trueProps={{ sx: { display: 'none' } }}
		{...props}
	/>
}
